
    import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
    import Util from '@/lib/util'
    import AbpBase from '@/lib/abpbase'
    import PageRequest from '@/store/entities/page-request'
    import Enums from '@/lib/enums'
    import DateUtils from '@/common/js/DateUtils'
    import CustomName from './custom-shopname.vue'
    import Preview from 'vue-photo-preview'
    import 'vue-photo-preview/dist/skin.css'
    Vue.use(Preview);

    class PageFreightRequest extends PageRequest {

    }

    @Component
        ({
            name: "authorizationshoplist",
            components: { CustomName }
        })
    export default class AuthorizationShop extends AbpBase {
        @Prop({ type: Boolean, default: false }) value: boolean;
        pagerequest: PageFreightRequest = new PageFreightRequest();
        CustomNameShow: boolean = false;
        orderloading: boolean = false;
        get list() {
            return this.$store.state.authorizationShop.list;
        };
        get loading() {
            return this.$store.state.authorizationShop.loading;
        }
        //get orderloading() {
          
        //    return this.$store.state.authorizationShop.loading;
        //}
         
        async GetShop() {
           var url = await this.$store.dispatch({
               type: 'authorizationShop/getUrl',
               data: {}
           })
            window.open(url);
           
        }
        async Synchronization() {
            var selectionData: any = this.$refs.selection;
            var selection = selectionData.getSelection();
            if (!selection || selection.length == 0) {
                this.$Message.error("选中项不能为空！");
                return;
            }
            var ids = [];
            for (var i = 0; i < selection.length; i++) {
                ids.push(selection[i].shopId);
            }
            this.orderloading = true
            var flag =await this.$store.dispatch({
                type: 'authorizationShop/SynchronizationOrder',
                data: { ShopIds: ids }
            }).finally(() => {
                this.$Message.success("同步订单成功");
                this.orderloading = false;
            });

        }

        async DeleteShop() {
            var selectionData: any = this.$refs.selection;
            var selection = selectionData.getSelection();
            if (!selection || selection.length == 0) {
                this.$Message.error("选中项不能为空！");
                return;
            }
            var data=[];
            for (var i = 0; i < selection.length; i++) {
                data.push(selection[i].id);

            }
            await this.$store.dispatch({
                type: 'authorizationShop/deleteAuthorizationShopList',
                data: { ids: data }
            });
            this.getpage();
        }

        async CancelShop() {
            var url = await this.$store.dispatch({
                type: 'authorizationShop/getCancelUrl',
                data: {}
            })
            window.open(url);
        }
        
        create() {
          
        }
        pageChange(page: number) {
            this.$store.commit('authorizationShop/setCurrentPage', page);
            this.getpage();
        }
        pagesizeChange(pagesize: number) {
            this.$store.commit('authorizationShop/setPageSize', pagesize);
            this.getpage();
        }

        async SearShop() {
            this.getpage();
        }

        async getpage() {

            this.pagerequest.maxResultCount = this.pageSize;
            this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;


            await this.$store.dispatch({
                type: 'authorizationShop/getAll',
                data: this.pagerequest
            })
        }
        async operationData(data: any) {
            this.$store.state.authorizationShop.shopid = data.shopId;
            this.CustomNameShow = true;
        }
        get pageSize() {
            return this.$store.state.authorizationShop.pageSize;
        }
        get totalCount() {
            return this.$store.state.authorizationShop.totalCount;
        }
        get currentPage() {
            return this.$store.state.authorizationShop.currentPage;
        }
        columns = [
            {
                type: 'selection',
                width: 50,
                align: 'center',
                fixed: 'left',
            },
            {
                title: '店铺Id',
                key: 'shopId',
                width: 150,
                fixed: 'left',
            },{
                title: '用户Id',
                key: 'userId',
                width: 150,
            },
            {
                title: '自定义名称',
                key: 'customShopName',
                width: 150,
            },{
                title: '店铺名',
                key: 'shopName',
                width: 150,
            }, {
                title: '店铺站点',
                width: 150,
                key: 'country',
                render: (h: any, params: any) => {
                    return h('span', Enums.ShopSiteType.filter(function (item) { return item.value == params.row.country })[0].name);
                }
            },
            {
                title: '状态',
                width: 150,
                key: 'shopeeStatus',
                render: (h: any, params: any) => {
                    return h('span', Enums.ShopStatus.filter(function (item) { return item.value == params.row.shopeeStatus })[0].name);
                }
            },
            {
                title: '授权时间',
                key: 'authTime',
                width: 150,
                render: (h: any, params: any) => {
                    return h('span', params.row.authTime ? DateUtils.formatLongDate(new Date(params.row.authTime)) : '');
                }
            },
            {
                title: '到期时间',
                key: 'expireTime',
                width: 150,
                render: (h: any, params: any) => {
                    return h('span', params.row.expireTime ? DateUtils.formatLongDate(new Date(params.row.expireTime)) : '');
                }
            },
            {
                title: '操作',
                key: 'action',
                width: 150,
                align: 'center',
                render: (h, params) => {
                    var _this = this;
                    return h('div', [
                        h('Button', {
                            props: {
                                type: 'primary',
                                size: 'small'
                            },
                            style: {
                                marginRight: '5px'
                            },
                            on: {
                                click: () => {
                                    _this.operationData(params.row)
                                }
                            }
                        }, '修改名称'),
                    ]);
                }
            }]
        async created() {
            this.getpage();
        }
    }
